import * as yup from 'yup';

export const validationSchema = yup.object({
  reading: yup.number().required('This field is required'),
  learning: yup.number().required('This field is required'),
  numeracy: yup.number().required('This field is required'),
  oral: yup.number().required('This field is required'),
  writing: yup.number().required('This field is required'),
});
